import { useMemo } from "react";
import { IconButton, Tooltip } from "@mui/material";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import SettingsBrightnessRoundedIcon from "@mui/icons-material/SettingsBrightnessRounded";

import { ThemeMode, useThemeStore } from "../store/themeStore";

const modes: ThemeMode[] = ["system", "light", "dark"];

export function ThemeModeSwitch() {
  const { mode, setMode } = useThemeStore();

  const icon = useMemo(() => {
    if (mode === "light") return <LightModeRoundedIcon />;
    if (mode === "dark") return <DarkModeRoundedIcon />;
    return <SettingsBrightnessRoundedIcon />;
  }, [mode]);

  const title = useMemo(() => {
    if (mode === "light") return "Tema chiaro";
    if (mode === "dark") return "Tema scuro";
    return "Tema automatico";
  }, [mode]);

  return (
    <Tooltip title={title} arrow>
      <IconButton
        color="inherit"
        onClick={() => {
          const index = modes.indexOf(mode);
          const next = modes[(index + 1) % modes.length];
          setMode(next);
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
}
